module.exports = __webpack_public_path__ + "img/sheets.10778170.svg";